var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medical (1) 1",
    clipPath: "url(#clip0_9487_164612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.4987 8.33333C5.2012 8.33333 3.33203 6.46417 3.33203 4.16667C3.33203 1.86917 5.2012 0 7.4987 0C9.7962 0 11.6654 1.86917 11.6654 4.16667C11.6654 6.46417 9.7962 8.33333 7.4987 8.33333ZM7.4987 1.25C5.89036 1.25 4.58203 2.55833 4.58203 4.16667C4.58203 5.775 5.89036 7.08333 7.4987 7.08333C9.10703 7.08333 10.4154 5.775 10.4154 4.16667C10.4154 2.55833 9.10703 1.25 7.4987 1.25Z",
    fill: "#172B4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.41667 17.5H0.625C0.28 17.5 0 17.22 0 16.875V13.9583C0 11.7758 1.77583 10 3.95833 10H11.0417C12.1208 10 13.1608 10.445 13.895 11.22C14.1325 11.4708 14.1217 11.8658 13.8708 12.1033C13.62 12.34 13.2242 12.3292 12.9875 12.0792C12.4875 11.5517 11.7783 11.2492 11.0417 11.2492H3.95833C2.465 11.2492 1.25 12.4642 1.25 13.9575V16.2492H5.41667C5.76167 16.2492 6.04167 16.5292 6.04167 16.8742C6.04167 17.2192 5.76167 17.5 5.41667 17.5Z",
    fill: "#172B4D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0833 19.9991C11.8592 19.9991 11.6525 19.8791 11.5408 19.6841L10.0542 17.0824H8.125C7.78 17.0824 7.5 16.8024 7.5 16.4574C7.5 16.1124 7.78 15.8324 8.125 15.8324H10.4167C10.6408 15.8324 10.8483 15.9524 10.9592 16.1474L12.0242 18.0108L14.0158 13.6949C14.115 13.4808 14.3267 13.3399 14.5625 13.3324C14.8067 13.3241 15.0192 13.4508 15.1317 13.6574L17.4542 17.9149H19.375C19.72 17.9149 20 18.1949 20 18.5399C20 18.8849 19.72 19.1658 19.375 19.1658H17.0833C16.855 19.1658 16.6442 19.0408 16.535 18.8399L14.63 15.3474L12.6508 19.6358C12.5525 19.8483 12.3442 19.9883 12.1108 19.9983C12.1008 19.9991 12.0925 19.9991 12.0833 19.9991Z",
    fill: "#172B4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9487_164612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientTab);
export default __webpack_public_path__ + "static/media/clientTab.a4df16f34a20acf5ae0f557c4058f8bf.svg";
export { ForwardRef as ReactComponent };